import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { HeadBarComponent } from './layout/head-bar/head-bar.component';
import { NavigationComponent } from './layout/navigation/navigation.component';
import { MainLayoutComponent } from './layout/main-layout/main-layout.component';
import { SharedModule } from '../shared/shared.module';
import { PrimeNgModule } from '../prime-ng.module';

@NgModule({
  declarations: [HeadBarComponent, NavigationComponent, MainLayoutComponent],
  imports: [CommonModule, RouterModule, PrimeNgModule, SharedModule],
  providers: [],
  exports: [HeadBarComponent, NavigationComponent],
})
export class CoreModule {}
